module.exports = __webpack_public_path__ + "static/media/video3-min.5318aa73.mov";